@app.directive 'shopifyButton', ($state, csConfig, ShopifyService, LocationService, ModalService, AnalyticsService, $location, DiscountService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'shopifyButton'
  controller: ->

    @discountCode = DiscountService.discountCode
    @discount = DiscountService.discount # Will go away one /butchers?discount_id is finished

    @isInUS = ->
      LocationService.isInUS()

    @isJoule = =>
      @sku == 'cs10001'

    @currentUser = $state.currentUser

    if @sku
      @product = ShopifyService.productForSku @sku
      if @product
        if @discount && @discount.valid # Will go away one /butchers?discount_id is finished
          @url = "#{csConfig.shopifyEndpoint}/cart/#{@product.variant_id}:1?discount=#{@discount.code}"
        else if @discountCode
          @url = "#{csConfig.shopifyEndpoint}/cart/#{@product.variant_id}:1?discount=#{@discountCode}"
        else if @currentUser
          @url = "#{csConfig.chefstepsEndpoint}/api/v0/shopping/users/add_to_cart?variant_id=#{@product.variant_id}"
        else
          @url = "#{csConfig.shopifyEndpoint}/cart/add?id=#{@product.variant_id}"

        switch @sku
          when 'cs10001'
            # Button behavior for Joule
            if @isInUS()
              @showInternational = false
              @buttonPrice = @product.price
            else
              @showInternational = true
              @openInternationalJoule = ->
                ModalService.open('internationalJoule', {type: 'normal', sku: @sku, user: @currentUser, checkoutUrl: @url, outOfStock: @product.inventory_quantity <= 0})
          else
            @buttonPrice = @product.price
      else
        Rollbar.error("ShopifyButton - @product not set for button at url: #{$state.current.url}")

    @openJouleWaitlist = ->
      AnalyticsService.track 'Joule Waitlist Modal Opened'
      ModalService.open('jouleWaitlist')

    @showOutOfStock = =>
      return false if !@product
      return false if @product.inventory_quantity > 0
      return false if @showInternational
      return false if @allowOutOfStockPurchase()
      (@showQuantity || @isJoule())



    @allowOutOfStockPurchase = =>
      # At the moment only checks the validity of the discount, allowing a user to purchase when out of stock
      # Typically, when an item is out of stock, we won't allow the customer to purchase
      # This allows us to retain the out of stock behavior but still allow a set of customers (from a promotion or campaign) to still purchase the out of stock item
      @discount?.valid

    @showDiscountMessage = =>
      if @discount
        (@discount?.valid && @discount?.code != 'allowOutOfStockPurchase') ? true : false

    this

  bindToController: {
    title: '='
    theme: '='
    sku: '='
    showPrice: '='
    showQuantity: '='
  }
  templateUrl: "/assets/templates/components/customButton/shopifyButton/shopifyButton.html"
